/** Organization datagrid key base — full key is `${USER_ROLES_DATAGRID_KEY}_${organizationId}` */
export const USER_ROLES_DATAGRID_KEY = "User Roles_grid";

export const USER_ROLE_DEFAULT_COLUMNS = [
  {
    field: "name",
    label: "Role Name",
    visible: true,
    width: 180,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "description",
    label: "Description",
    visible: true,
    width: 220,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
];

export const USER_ROLE_PERSONALIZE_CONFIG = {
  defaultVisibleColumns: USER_ROLE_DEFAULT_COLUMNS.map((col) => col.field),
  columnLabels: Object.fromEntries(
    USER_ROLE_DEFAULT_COLUMNS.map((col) => [col.field, col.label])
  ),
  columnWidths: Object.fromEntries(
    USER_ROLE_DEFAULT_COLUMNS.map((col) => [col.field, col.width])
  ),
};

export const USER_ROLE_PERSONALIZE_COLUMN_KEYS =
  USER_ROLE_DEFAULT_COLUMNS.map((col) => col.field);

const COLUMN_FIELD_ALIASES = {
  role_name: "name",
  user_role_name: "name",
  role_description: "description",
};

const METADATA_FILTER_FIELDS = new Set(["role_name", "role_description"]);

export function normalizeUserRoleColumnField(field) {
  const raw = String(field || "").trim();
  if (!raw) return raw;
  if (COLUMN_FIELD_ALIASES[raw]) return COLUMN_FIELD_ALIASES[raw];
  const lower = raw.toLowerCase();
  return COLUMN_FIELD_ALIASES[lower] || raw;
}

export function resolveUserRoleApiField(field) {
  const raw = String(field || "").trim();
  if (raw === "role_description") return "description";
  if (METADATA_FILTER_FIELDS.has(raw)) return raw;
  const normalized = normalizeUserRoleColumnField(field);
  if (normalized === "name") return "role_name";
  if (normalized === "description") return "description";
  return normalized;
}

export function mapSavedUserRoleColumns(savedColumns = []) {
  const labelByField = USER_ROLE_PERSONALIZE_CONFIG.columnLabels || {};

  return savedColumns
    .map((col) => {
      const field = normalizeUserRoleColumnField(col.field || col.key);
      if (!field || field === "organization_user_role_id") return null;

      const defaultCol = USER_ROLE_DEFAULT_COLUMNS.find((c) => c.field === field);

      return {
        ...(defaultCol || {}),
        ...col,
        field,
        key: field,
        label: col.label || labelByField[field] || field,
        visible: col.visible !== false,
        filterable: col.filterable !== false,
        sortable: col.sortable !== false,
      };
    })
    .filter(Boolean);
}

export function mapUserRoleRowForDisplay(item) {
  const roleId = item.organization_user_role_id ?? item.id;
  const roleName =
    item.name || item.user_role_name || item.role_name || "";

  return {
    ...item,
    organization_user_role_id: roleId,
    application_user_role_id: item.application_user_role_id,
    id: roleId,
    name: roleName,
    user_role_name: item.user_role_name || item.role_name || roleName,
    role_name: item.role_name || roleName,
    description: item?.description == null ? "" : item.description,
    is_custom: !!item.is_custom,
  };
}
